import { useNavigate } from 'react-router';
import { DropdownItem } from 'reactstrap';
import { useMutation } from '@apollo/client';
import { captureEvent } from '../../utils/analytics';
import { CreateTemplateFromCrop as mutation } from '../../mutations';

// Handles creating a new template from a crop.
const CreateTemplateFromCrop = ({
  id,
  mutateAndSetState,
  publicTemplate = false,
}) => {
  const [mutate] = useMutation(mutation);
  const navigate = useNavigate();

  const createTemplate = () => {
    mutateAndSetState(() =>
      mutate({
        variables: { input: { id, default: publicTemplate } },
      }).then((response) => {
        const { result } = response.data?.createTemplateFromCrop || {};
        if (result) {
          const basePath = result.team
            ? `/app/team/${result.team.id}`
            : '/superadmin';
          navigate(`${basePath}/templates/${result.id}/edit`);
        }
        return response;
      }),
    );
    if (!publicTemplate) {
      captureEvent('create-team-template-from-crop', { id });
    }
  };

  return (
    <DropdownItem onClick={createTemplate}>
      {`Create ${publicTemplate ? 'Public' : 'Team'} Template`}
    </DropdownItem>
  );
};

export default CreateTemplateFromCrop;
